import { useEffect, useMemo } from 'react';
import {
    useGlobalPrompt,
    useHasElectricCar,
    useIsEvPluggedIn,
    useHasSales,
    useIsAwaitingSmartChargingUserSoc,
    useIsGridXCustomer,
    useIsGridXGatewayRescanning,
    useWallboxSmartChargingData,
    useWallboxDeviceConfiguration,
} from '@store/selectors';
import Prompt from '@components/prompt';
import { useSmartCharging } from '@containers/emobility/charging-modes/shared/hooks';
import { checkForScopes } from '@tools/utils';
import { Scope } from '@tools/enums';

export const GlobalPrompt = () => {
    const globalPrompt = useGlobalPrompt();
    const isEvPluggedIn = useIsEvPluggedIn();
    const isGridXCustomer = useIsGridXCustomer();
    const hasElectricCar = useHasElectricCar();
    const hasCombinedChargingScope = checkForScopes([
        Scope.EMOBILITY_COMBINED_CHARGING_READ,
    ]);
    const hasSales = useHasSales();
    const isGridXGatewayRescanning = useIsGridXGatewayRescanning();
    const isAwaitingSmartChargingUserSoc = useIsAwaitingSmartChargingUserSoc();
    const wallboxDeviceConfiguration = useWallboxDeviceConfiguration();
    const { active: isSmartChargingActivate } = useWallboxSmartChargingData();
    const { handleSmartChargingCarConnect } = useSmartCharging();

    // finish onboarding/rescanning, is a GridX customer with the combined charging scope, enable smart charging, has set a user SoC, not connect enode yet, and is awaiting the user SoC for smart charging
    const shouldPromptCarConnect = useMemo(
        () =>
            !hasSales &&
            !isGridXGatewayRescanning &&
            isGridXCustomer &&
            hasCombinedChargingScope &&
            isSmartChargingActivate &&
            wallboxDeviceConfiguration?.userSoc &&
            !hasElectricCar &&
            isAwaitingSmartChargingUserSoc,
        [
            hasCombinedChargingScope,
            hasElectricCar,
            hasSales,
            isAwaitingSmartChargingUserSoc,
            isGridXCustomer,
            isGridXGatewayRescanning,
            isSmartChargingActivate,
            wallboxDeviceConfiguration?.userSoc,
        ],
    );

    useEffect(() => {
        if (isEvPluggedIn && shouldPromptCarConnect) {
            handleSmartChargingCarConnect();
        }
    }, [isEvPluggedIn, shouldPromptCarConnect, handleSmartChargingCarConnect]);

    return (
        globalPrompt.visible &&
        globalPrompt.promptProps?.children && (
            <Prompt {...globalPrompt.promptProps} />
        )
    );
};

export default GlobalPrompt;
